import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService, ZapierEventTypes } from '../shared/api.service';
import { EbiService } from '../shared/ebi.service';
import { Email } from '../email-template/email-template.component';
import {ActivatedRoute, Router} from '@angular/router';
import { AuthenticationService } from '../shared/authentication.service';



@Component({
  selector: 'app-test-details-card',
  templateUrl: './test-details-card.component.html',
  styleUrls: ['./test-details-card.component.css']
})
export class TestDetailsCardComponent implements OnInit {
  @Input() selectedItem: any; // selected test
  @Input() userSavedPlaces: any; // user saved places
  @Input() userSavedWaterSources: any; // user saved water sources
  @Input() idToken: string; // user id token
  @Input() apiUid: string; // user api uid
  @Input() locationEditNeeded: boolean; // flag to indicate if location edit is needed
  @Input() headerNeeded: boolean; // flag to indicate if header is needed
  @Input() footerNeeded: boolean; // flag to indicate if footer is needed
  @Input() userEmail: string; // user email
  @Input() locationHeaderNeeded: boolean; // flag to indicate if location header is needed
  @Output() pdfEvent: EventEmitter<any> = new EventEmitter(); // pdf event emitter
  @Output() updateDataEvent: EventEmitter<any> = new EventEmitter<any>(); // update data event emitter
  testLoaded = false; // flag to indicate if test is loaded
  isEditingLocation = false; // flag to indicate if location is being edited
  isEditingWaterSource = false; // flag to indicate if water source is being edited
  isEditingNote = false; // flag to indicate if note is being edited
  testDate; // test date
  email: Email; // email object
  userDisplayName: string; // user display name

  constructor(private apiService: ApiService, private ebiService: EbiService, private router: Router, private authenticationService: AuthenticationService) {
  }

  async ngOnInit(): Promise<void> {
    if (!this.userDisplayName) { // if user display name is not set
      const userData = await this.apiService.getUserData(this.selectedItem?.uid, this.idToken); // get user data
      this.userDisplayName = userData.data?.displayName; // set user display name
    }
    this.testLoaded = true;
    this.testDate = new Date((this.selectedItem?.calculationResult.date.seconds * 1000 ||
      this.selectedItem?.calculationResult.date._seconds * 1000)).toLocaleString('en-US', {timeZoneName: 'short'}); // set test date
    if (this.userEmail) { // if user email is set

      // set email object
      this.email = {
        to: [this.userEmail], // set to email
        from: 'ExactBlue', // set from email
        subject: this.selectedItem?.calculationResult.testType.charAt(0).toUpperCase() +
          this.selectedItem?.calculationResult.testType.slice(1) + ' test result for ' +
          (this.selectedItem?.location?.name || 'No Location Chosen') + ' on ' +
          this.testDate, // set subject
        // html template for email body. todo: put it in its own file
        html: '<h3>Your Test Result</h3>\n' + '<div class=\'row\'>\n' +
          '          <div class=\'col-12 col-lg-6 pb-2\'>\n' +
          '            <small class=\'d-block\'>DATE & TIME</small>\n' +
          '            <p\n' +
          '              class=\'card-text\'>' + this.testDate + '</p>\n' +
          '\n' +
          '          </div>\n' +
          '          <div class=\'col-12 col-lg-6 pb-2\'>\n' +
          '            <small class=\'d-block\'>TEST ID</small>\n' +
          '            <p\n' +
          '              class=\'card-text\'>' + this.selectedItem.calculationResult.testId + '</p>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '        <div class=\'row\'>\n' +
          '          <div class=\'col-12 col-lg-6 dropdown-container pb-2\'>\n' +
          '            <small class=\'d-block\'>LOCATION</small>\n' +
          '            <div class=\'card-text\'><p>\n' +
          '\n' +
          (this.selectedItem.location.formatted_address || this.selectedItem.location.name || (this.isString(this.selectedItem.location) ? (this.selectedItem.location || 'No Location Chosen') : 'No Location Chosen')) +
          '\n' +
          '            </p></div>\n' +
          '\n' +
          '          </div>\n' +
          '          <div class=\'col-12 col-lg-6 dropdown-container pb-2\'>\n' +
          '            <small class=\'d-block\'>WATER SOURCE</small>\n' +
          '            <div\n' +
          '              class=\'text-capitalize card-text\'><p>\n' +
          '\n' +
          (this.selectedItem.location?.waterSource !== undefined ? this.selectedItem.location?.waterSource ? this.selectedItem.location?.waterSource : 'No Water Source Chosen' : this.selectedItem.waterSource) +
          '            </p></div>\n' +
          '\n' +
          '\n' +
          '          </div>\n' +
          '        </div>\n' +
          '        <div class=\'row\'>\n' +
          '          <div class=\'col-12 col-lg-6 pb-2\'>\n' +
          '            <small class=\'d-block\'>DEVICE ID</small>\n' +
          '            <p class=\'card-text\'>' + this.selectedItem.calculationResult.deviceMacAddress + '</p>\n' +
          '          </div>\n' +
          '          <div class=\'col-12 col-xl-6 pb-2\'>\n' +
          '            <small class=\'d-block\'>RESULTS</small>\n' +
          '            <p class=\'card-text d-flex justify-content-between\'>' + this.selectedItem.calculationResult.textDescription + '<span>\n' +

          '      </span></p>\n' +
          '\n' +
          '          </div>\n' +
          '        </div>\n' +
          '        <div class=\'row\'>\n' +
          '          <div class=\'col-12\'>\n' +
          '            <small class=\'d-block\'>NOTES</small>\n' +
          '\n' +
          '            <div class=\'text-capitalize card-text\'><p>\n' + this.selectedItem.note || 'No Note' +
          '            </p></div>\n' +
          '          </div>\n' +
          '        </div>',
        attachments: ['']
      };
    }
  }

  /**
   * Create a PDF file of the test result
   */
  createPdf() {
    this.pdfEvent.emit();
  }

  async getUserSavedData(event?) {
    if (event) {
      console.log(event.place_id);
      let locationName = '';
      const geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(event.lat, event.lng);
      geocoder.geocode({location: latlng}, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            locationName = results[0].formatted_address;
            this.apiService.updateTestData({
              location: {
                place_id: results[0]. place_id,
                name: locationName,
                formatted_address: locationName,
                lat: event.lat,
                lng: event.lng,
                waterSource: '',
              }
            }, this.selectedItem?.calculationResult.testId, this.apiUid, this.idToken);
            this.updateDataEvent.emit();
          } else {
            this.apiService.updateTestData({
              location: {
                place_id: results[0]. place_id,
                name: locationName,
                formatted_address: locationName,
                lat: event.lat,
                lng: event.lng,
                waterSource: '',
              }
            }, this.selectedItem?.calculationResult.testId, this.apiUid, this.idToken);
            this.updateDataEvent.emit();
          }
        } else {
          console.log('Error geocode: ', status);
        }
      });
    }
    this.updateDataEvent.emit();
  }

  async handleNoteChange($event: Event, testId: string) {
    await this.apiService.handleNoteChange($event, testId, this.apiUid, this.idToken); // update note
  }

  isString(location): boolean {
    return typeof location === 'string'; // check if location is a string
  }

  async navigateToTest(testId: string) {
    await this.router.navigate(['/test' + '/' + testId]); // navigate to test
  }

  /**
   * Delete a test result
   * @param test - test result to delete
   */
  async deleteTest(test) {
    const data = {
      isArchived: true
    };

    // update test result
    await this.apiService.updateTestData(data, test.calculationResult.testId, test.uid, this.idToken);

    // navigate home
    await this.router.navigate(['/']);
  }

  async updateMap(event) {
    await this.getUserSavedData(event);
    console.log(event);
    // const lat = $event.lat;
    // const lng = $event.lng;
    // this.position = {lat, lng};
  }
}
